<template>
  <span
    v-if="node.type === 'text'"
    :class="textClass"
    >{{ node.text }}</span
  >
  <!-- 未知节点：退化为纯文本段落，不按未知结构渲染 -->
  <p v-else-if="!isKnownNodeType(node.type)" :class="fallbackClass">
    {{ nodePlainText(node) }}
  </p>
  <component :is="tag" v-else :class="nodeClass">
    <rich-media-node v-for="(child, index) in node.children || []" :key="index" :node="child" />
  </component>
</template>

<script>
import { nodeTag, hasMark, isKnownNodeType, nodePlainText } from './document'
import { RICH_MEDIA_CLASSES, richMediaNodeClasses } from './contract'

const LEGACY_NODE_CLASSES = {
  paragraph: 'rich-media-node--paragraph',
  heading: 'rich-media-node--heading',
  list: 'rich-media-node--list',
  list_item: 'rich-media-node--list_item',
  blockquote: 'rich-media-node--blockquote',
  code: 'rich-media-node--code'
}

export default {
  name: 'RichMediaNode',
  props: { node: { type: Object, required: true } },
  computed: {
    tag() {
      return nodeTag(this.node)
    },
    nodeClass() {
      return ['rich-media-node', LEGACY_NODE_CLASSES[this.node.type], ...richMediaNodeClasses(this.node.type)]
    },
    fallbackClass() {
      return ['rich-media-node', 'rich-media-node--fallback', RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.fallbackNode]
    },
    textClass() {
      return [
        RICH_MEDIA_CLASSES.textNode,
        {
          'is-bold': hasMark(this.node, 'bold'),
          [RICH_MEDIA_CLASSES.bold]: hasMark(this.node, 'bold'),
          'is-italic': hasMark(this.node, 'italic'),
          [RICH_MEDIA_CLASSES.italic]: hasMark(this.node, 'italic'),
          'is-underline': hasMark(this.node, 'underline'),
          [RICH_MEDIA_CLASSES.underline]: hasMark(this.node, 'underline'),
          'is-strike': hasMark(this.node, 'strikethrough'),
          [RICH_MEDIA_CLASSES.strike]: hasMark(this.node, 'strikethrough')
        }
      ]
    }
  },
  methods: { hasMark, isKnownNodeType, nodePlainText }
}
</script>
